<div
  class="loading-screen-wrapper"
  *ngIf="
    (isEOMLoading$ | async) ||
      (isBridgingToSDKQSet$ | async) ||
      (areQuotesLoading$ | async) ||
      (isQueSetLoading$ | async) ||
      (isAppFormLoading$ | async) ||
      (isSyncedWithBP$ | async) === false;
    else ready
  "
>
  <mat-spinner></mat-spinner>
</div>
<ng-template #ready>
  <application-form-web-component
    [activeMenuOrder$]="activeMenuOrder$"
    [isReferred]="isReferred"
    [readOnlyMode$]="readOnlyMode$"
    [data]="sdkInitData"
    [applicationHost]="'BP'"
    [application_state$]="appFormState$"
    [carrierProducts$]="carrierProducts$"
    [isOwner$]="isOwner$"
    (onInputvalueChange)="onInputValueChange($event)"
    (onSaveButtonClick)="onSaveButtonClicked($event)"
    (onSaveButtonBlur)="onSaveButtonBlurred($event)"
    (onSaveButtonFocus)="onSaveButtonFocused($event)"
    (onInputInit)="onInputInit()"
    (onQuoteBind)="onQuoteBindCalled($event)"
    (onExploreMarketsClick)="onExploreMarketsClicked($event)"
    (onQuoteViewDetailsClick)="onQuoteViewDetailsClicked($event)"
    (onQuoteRequestView)="onQuoteRequestView($event)"
  >
  </application-form-web-component>
</ng-template>
